/* eslint-disable no-magic-numbers */
import {
	STUDENT_LOANS_REFINANCE_DEFAULT_PATH,
	TAX_PREPARATION_SERVICES_PATH,
} from "@/config/site/thecreditreview";
import {
	getCompanyListHeaderColumnCount,
	getHeaderParts,
	getPreventRenderingCompanyListHeader,
	getVertical,
} from "@/selectors";
import { useSelector } from "react-redux";

export const CompanyListHeader = () => {
	const vertical = useSelector(getVertical);
	const headerParts = useSelector(getHeaderParts);
	const columnCount = useSelector(getCompanyListHeaderColumnCount);
	const preventRenderingCompanyListHeader = useSelector(
		getPreventRenderingCompanyListHeader,
	);

	if (preventRenderingCompanyListHeader || !headerParts) {
		return null;
	}

	const gridColsClass = {
		2: "tw:grid-cols-[197px_150px_150px_auto] tw:lg2:grid-cols-[246px_177px_177px_auto]",
		3: "tw:grid-cols-[197px_100px_100px_100px_auto] tw:lg2:grid-cols-[246px_118px_118px_118px_auto]",
		4: "tw:grid-cols-[197px_75px_75px_75px_75px_auto] tw:lg2:grid-cols-[246px_88px_88px_88px_88px_auto]",
	}[columnCount];

	const getWrapperMarginClass = () => {
		if (vertical === STUDENT_LOANS_REFINANCE_DEFAULT_PATH) {
			return "tw:mt-[15px]";
		}
		if (vertical === TAX_PREPARATION_SERVICES_PATH) {
			return "tw:mt-5 tw:mb-5";
		}
		return "tw:mt-[30px]";
	};

	const isTaxPrepVertical = vertical === TAX_PREPARATION_SERVICES_PATH;

	const liBaseClasses =
		"tw:font-montserrat tw:font-semibold tw:bg-none tw:p-0 tw:m-0 tw:w-full";
	const liTextClasses = isTaxPrepVertical
		? "tw:text-gray-700 tw:normal-case tw:text-sm tw:tracking-normal tw:leading-[1.3]"
		: "tw:uppercase tw:text-[11px] tw:lg2:text-xs tw:text-[#48484b] tw:tracking-[0.03em] tw:leading-[1.3]";

	return (
		<div
			className={`tw:hidden tw:bg-white tw:lg:block ${getWrapperMarginClass()}`}
		>
			<ul
				className={`company-list-header tw:m-0 tw:grid tw:list-none tw:items-center tw:p-[11px_0] tw:pl-[10px] tw:lg2:p-[16px_0_12px_0] tw:lg2:pl-0 company-list-header--cols-${columnCount} ${gridColsClass}`}
			>
				{headerParts.map((part, idx) => (
					<li key={idx} className={`${liBaseClasses} ${liTextClasses}`}>
						{part}
					</li>
				))}
			</ul>
		</div>
	);
};
